export class Deferred extends Promise {
    constructor() {
        if (arguments.length > 0) {
            // fallback to Promise constructor
            // eslint-disable-next-line prefer-rest-params
            super(arguments[0]);
            this.resolve = () => { throw new Error('Deferred.resolve is not callable'); };
            this.reject = () => { throw new Error('Deferred.reject is not callable'); };
            return;
        }
        let _resolve;
        let _reject;
        super((resolve, reject) => {
            _resolve = resolve;
            _reject = reject;
        });
        this.resolve = _resolve;
        this.reject = _reject;
    }
}
export default Deferred;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmZXJyZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZGVmZXJyZWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxPQUFPLFFBQVksU0FBUSxPQUFVO0lBQ3ZDO1FBQ0ksSUFBSSxTQUFTLENBQUMsTUFBTSxHQUFHLENBQUMsRUFBRTtZQUN0QixrQ0FBa0M7WUFDbEMsOENBQThDO1lBQzlDLEtBQUssQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtZQUNuQixJQUFJLENBQUMsT0FBTyxHQUFHLEdBQUcsRUFBRSxHQUFHLE1BQU0sSUFBSSxLQUFLLENBQUMsa0NBQWtDLENBQUMsQ0FBQSxDQUFDLENBQUMsQ0FBQTtZQUM1RSxJQUFJLENBQUMsTUFBTSxHQUFHLEdBQUcsRUFBRSxHQUFHLE1BQU0sSUFBSSxLQUFLLENBQUMsaUNBQWlDLENBQUMsQ0FBQSxDQUFDLENBQUMsQ0FBQTtZQUMxRSxPQUFNO1NBQ1Q7UUFFRCxJQUFJLFFBQXlDLENBQUE7UUFDN0MsSUFBSSxPQUFtQyxDQUFBO1FBQ3ZDLEtBQUssQ0FBQyxDQUFDLE9BQU8sRUFBRSxNQUFNLEVBQUUsRUFBRTtZQUN0QixRQUFRLEdBQUcsT0FBTyxDQUFBO1lBQ2xCLE9BQU8sR0FBRyxNQUFNLENBQUE7UUFDcEIsQ0FBQyxDQUFDLENBQUE7UUFFRixJQUFJLENBQUMsT0FBTyxHQUFHLFFBQVMsQ0FBQTtRQUN4QixJQUFJLENBQUMsTUFBTSxHQUFHLE9BQVEsQ0FBQTtJQUMxQixDQUFDO0NBSUo7QUFFRCxlQUFlLFFBQVEsQ0FBQSJ9